import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core'
import { GenericLayer } from '../../../../shared/model/layers/generic-layer'
import { BehaviorSubject, Observable, take } from 'rxjs'
import {
    LayerGroupInfo,
    LayerGroupReference,
    LayerGroupReferenceDeprecated,
    LayerReference,
} from '../layer-groups/layer-groups.model'
import { Store } from '@ngrx/store'
import { selectSearchKey } from 'src/app/state/viewer/viewer.selectors'
import { SelectionName } from 'src/app/state/selection/selection.state'

@Component({
    selector: 'app-layer-group',
    templateUrl: './layer-group.component.html',
    styleUrls: ['./layer-group.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LayerGroupComponent {
    // TODO: use layer-groups-component for selections as well
    @Input() groupInfo: LayerGroupInfo
    @Input() showToggleAllButtons = false
    @Input() set layers(layers: GenericLayer[]) {
        if (this.groupInfo.name === SelectionName.Free) {
            this.store.select(selectSearchKey).subscribe(searchKey => {
                const filteredLayers = layers.filter(l => {
                    return (
                        l.name === undefined ||
                        l.name?.toLowerCase().includes(searchKey.toLowerCase())
                    )
                })
                this._layers$.next(filteredLayers)
            })
        } else {
            this._layers$.next(layers)
        }
    }

    @Output() selectLayer = new EventEmitter<LayerReference>()
    @Output() selectLayerGroup = new EventEmitter<LayerGroupReferenceDeprecated>()
    @Output() toggleListOpen = new EventEmitter<string>()

    private _layers$: BehaviorSubject<GenericLayer[]> = new BehaviorSubject([])
    layers$: Observable<GenericLayer[]> = this._layers$.asObservable()
    numOfVisibleLayers: number = 0
    readonly searchKeyExists$ = this.store.select(selectSearchKey)
    listOpen = true

    constructor(private readonly store: Store) {}

    ngOnInit(): void {
        this._layers$.subscribe(layers => {
            let count = 0
            layers.forEach(l => {
                l.visible$.subscribe(ll => {
                    if (ll) count++
                })
            })
            this.numOfVisibleLayers = count
        })
    }

    layerSelected($event: LayerReference): void {
        this.selectLayer.emit($event)
    }

    showAllLayers(): void {
        this.store
            .select(selectSearchKey)
            .pipe(take(1))
            .subscribe(searchKey => {
                this._layers$.value
                    .filter(l => l.name?.toLowerCase().includes(searchKey.toLowerCase()))
                    .forEach(layer => layer.setVisible(true))
            })
    }

    hideAllLayers(): void {
        this.store
            .select(selectSearchKey)
            .pipe(take(1))
            .subscribe(searchKey => {
                this._layers$.value
                    .filter(l => l.name?.toLowerCase().includes(searchKey.toLowerCase()))
                    .forEach(layer => layer.setVisible(false))
            })
    }

    layerGroupSelected($event: LayerGroupReference): void {
        this.selectLayerGroup.emit({
            layers: this._layers$.value,
            groupName: $event.groupName,
            elementId: $event.elementId,
        })
    }

    toggleLayerGroup(): void {
        this.toggleListOpen.emit(this.groupInfo.name)
    }
}
